import { post } from '@/utils/request';

// 审核/批准 报告
export const editFlowState = params => {
  return post(`/app/flow/editFlowState`, params);
};

// 设备材料检测 审核/批准 报告
export const editTotEntrustmentState = params => {
  return post(`/app/tot/editTotEntrustmentState`, params);
};

// 工程质量检测 审核/批准 报告
export const editProjectStageState = params => {
  return post(`/app/tot/editProjectStageState`, params);
};

// 审核/批准 物料出库
export const editMtApplyState = params => {
  return post(`/app/editMtApplyState`, params);
};
